import {
  ADD_MONEY_FROM_MOBILE_OPERATOR_ERROR,
  ADD_MONEY_FROM_MOBILE_OPERATOR_START,
  ADD_MONEY_FROM_MOBILE_OPERATOR_SUCCESS,
  CLEAR_ADD_MONEY_FROM_MOBILE_OPERATOR_STORE,
} from 'constants/action-types/addMoney/addMoneyFromMobileOperator';

export default (state, { type, payload }) => {
  switch (type) {
    case ADD_MONEY_FROM_MOBILE_OPERATOR_START:
      return {
        ...state,
        addMoneyFromMobileOperator: {
          ...state.addMoneyFromMobileOperator,
          loading: true,
          error: null,
        },
      };
    case ADD_MONEY_FROM_MOBILE_OPERATOR_ERROR:
      return {
        ...state,
        addMoneyFromMobileOperator: {
          ...state.addMoneyFromMobileOperator,
          error: payload,
          loading: false,
        },
      };
    case ADD_MONEY_FROM_MOBILE_OPERATOR_SUCCESS:
      return {
        ...state,
        addMoneyFromMobileOperator: {
          ...state.addMoneyFromMobileOperator,
          error: null,
          loading: false,
          data: payload,
        },
      };
    case CLEAR_ADD_MONEY_FROM_MOBILE_OPERATOR_STORE:
      return {
        ...state,
        addMoneyFromMobileOperator: {
          ...state.addMoneyFromMobileOperator,
          error: null,
          loading: false,
          data: null,
        },
      };
    default:
      return null;
  }
};
